import { render } from "./UserAccountSettings.vue?vue&type=template&id=24338370&scoped=true"
import script from "./UserAccountSettings.vue?vue&type=script&lang=js"
export * from "./UserAccountSettings.vue?vue&type=script&lang=js"

import "./UserAccountSettings.vue?vue&type=style&index=0&id=24338370&lang=scss&scoped=true"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24338370"]])

export default __exports__